import { createContext } from 'react';

interface AuthContextValue {
  isSignedIn: boolean;
  isLoading: boolean;
  /**
   * Callback function to refresh the authentication state.
   */
  refresh: () => Promise<void>;
  roles: string[];
  isInternal: boolean;
}

const AuthContext = createContext<AuthContextValue>({
  isSignedIn: false,
  isLoading: true,
  refresh: async () => {},
  roles: [],
  isInternal: false,
});

export default AuthContext;
